// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"1b991356","578":"85f65c0d","821":"7b3b2b1a","977":"459ae33c"}[chunkId] + ".chunk.js";
};